import styled from 'styled-components';

export const Text = styled.p`
  font: var(--font14M);
  color: ${({ $isRed }) => ($isRed ? 'var(--color-error)' : 'var(--color-text100)')};
`;
